export enum TIME_PERIODS {
    days = 'days',
    hours = 'hours',
    min = 'min',
    sec = 'sec'
}
